export enum PasswordHelper {
  error = 'Пароль - обязательное поле',
  ok = '',
}
